.header {
    display: flex;
    flex-direction: column;
    gap: var(--exo-spacing-small);
    margin: 0 0 var(--exo-spacing-medium);
}

.titleRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--exo-spacing-small);
}

.heading {
    margin: 0;
    font-weight: var(--exo-font-weight-bold);
}

.list {
    border: 1px solid var(--exo-color-border-secondary);
    border-radius: var(--exo-radius-large);
    overflow: hidden;
    background: var(--exo-color-background);
}

.pageDescription {
    font-size: var(--exo-font-size-small);
    color: var(--exo-color-font-secondary);
}

.empty {
    display: flex;
    justify-content: center;
    padding: var(--exo-spacing-2x-large) var(--exo-spacing-large);
    border: 1px dashed var(--exo-color-border-secondary);
    border-radius: var(--exo-radius-large);
}

.search {
    padding: var(--exo-spacing-standard);
}
